import type { AmountWithType, LinearBillablePrice } from '@domains/billing-settings/priv/CustomerDiscount/api/api'
import type { BillablePriceParser } from '@domains/billing-settings/priv/CustomerDiscount/api/mappers'
import type { Amount, AssignedPrice, LinearAlgorithm } from '@mynt/backoffice-api-spec/billables'

export class LinearPriceParser implements BillablePriceParser {
  supports(type: string): boolean {
    return type.toLowerCase() === 'linear'
  }

  parse(price: AssignedPrice): LinearBillablePrice {
    const linearAlgorithm = price.algorithm as LinearAlgorithm

    return {
      billableId: price.billableId,
      type: 'linear',
      coefficients: linearAlgorithm.coefficients.map((c) => ({ value: c.value, currency: c.currency })),
      constants: linearAlgorithm.constants.map((c) => ({ value: c.value, currency: c.currency })),
    }
  }

  parseAmountWithTypeFromConstantsAndCoefficients(constants: Amount[], coefficients: Amount[]): AmountWithType[] {
    let amounts: AmountWithType[] = []

    if (constants.length > 0) {
      amounts = amounts.concat(
        constants.map((c) => ({
          value: c.value,
          currency: c.currency,
          type: 'constant',
        })),
      )
    }

    if (coefficients.length > 0) {
      amounts = amounts.concat(
        coefficients.map((c) => ({
          value: c.value,
          currency: c.currency,
          type: 'coefficient',
        })),
      )
    }

    return amounts
  }
}
